
import { GoogleGenAI } from "@google/genai";

// Always initialize GoogleGenAI with process.env.API_KEY directly as per guidelines
const getAI = () => new GoogleGenAI({ apiKey: process.env.API_KEY });

const SYSTEM_INSTRUCTION = `
You are "DigiMaju AI Consultant", a professional and friendly assistant for a software house and digital solution company specializing in MSMEs (UMKM) in Indonesia.
Your goals:
1. Help users understand DigiMaju's products: Financial App for MSMEs, E-learning Platform, Online Shop App, and Custom Web/Mobile development.
2. Provide short, actionable business advice for MSMEs.
3. Use a professional, empowering, and polite tone (Bahasa Indonesia).
4. Encourage users to contact the DigiMaju team for professional services.
Keep responses concise (max 3-4 sentences).
`;

export const getAIResponse = async (userMessage: string) => {
  // Creating a new instance before the call to ensure the latest API key is used
  const ai = getAI();
  try {
    // Using ai.models.generateContent with the recommended Gemini 3 Flash model for text tasks
    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: userMessage,
      config: {
        systemInstruction: SYSTEM_INSTRUCTION,
        temperature: 0.7,
      },
    });
    // Accessing the .text property directly (not a method) as per SDK specifications
    return response.text || "Maaf, saya sedang mengalami kendala teknis. Silakan coba lagi nanti.";
  } catch (error) {
    console.error("Gemini Error:", error);
    return "Terjadi kesalahan saat menghubungi konsultan digital kami.";
  }
};
